import { render, staticRenderFns } from "./CheckboxDetailGroup.vue?vue&type=template&id=64e44012&scoped=true&"
import script from "./CheckboxDetailGroup.vue?vue&type=script&lang=js&"
export * from "./CheckboxDetailGroup.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxDetailGroup.vue?vue&type=style&index=0&id=64e44012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e44012",
  null
  
)

export default component.exports